import React, { useEffect, useState } from "react";
import { ourPartnersData } from "../common/Helper";
import { getPartner } from "../../services/PartnerServices";

const OurPartners = () => {
  const [partners, setPartner] = useState([]);

  useEffect(() => {
    getPartner().then((res) => {
      setPartner(res.data);
    });
  }, []);
  return (
    <div className="ourPartners_background">
      {/* <div className="container pt-lg-4">
        <h3 className=" fw-bold ff_inter text-center text-white  fs_48">
          Our Partners
        </h3>
        <div className="row col-md-9 mx-auto pb-lg-4 justify-content-between">
          {partners.map((item, index) => {
            return (
              <>
                <div key={index} className="col-md-4 p-4 mt-4">
                  <a href="#">
                    <img
                      className="w-100 h-100 rounded-2"
                      src={item.image}
                      alt=" Our Partners logo"
                    />
                  </a>
                </div>
              </>
            );
          })}
        </div>
      </div> */}
    </div>
  );
};

export default OurPartners;
